type TradeSourceLike = {
  sourceType?: unknown;
  source_type?: unknown;
};

export function isManualEntryTrade(trade: TradeSourceLike | null | undefined): boolean {
  if (!trade) return false;
  const source = [trade.sourceType, trade.source_type]
    .map((value) => String(value ?? '').trim().toLowerCase())
    .find(Boolean) ?? '';
  return source === 'manual';
}

export function hasManualEntryTrade(trades: readonly (TradeSourceLike | null | undefined)[]): boolean {
  return trades.some(isManualEntryTrade);
}
